<template>
  <v-dialog
    persistent
    v-model="showDialogFirstLogin"
    max-width="50%"
    :dark="compColor.isInDarkMode"
    :color="compColor.primeColor"
    overlay-opacity="0.9"
  >

    <div class="elevation-10 layout-column"
         style="border-radius: 6px;"
         :style="{background: compColor.contentFrame}">
      <!-- HEADER -->
      <div class="text-h6 font-weight-light pa-3 layout-row layout-align-center-center grey--text text--darken-2">
        <v-avatar tile
                  height="40"
                  width="40"
                  class="mr-0"
                  style="min-width:40px;">
          <v-icon :color="compColor.primeColor">mdi-fingerprint</v-icon>
        </v-avatar>
        <strong>{{ $t('AUTH.FIRST_LOGIN.HEADLINE') }}</strong>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>


      <div class="ma-1 px-3 pt-5 pb-3 layout-column elevation-3" style="border-radius: 5px;position: relative; overflow: hidden;" :style="{'background': compColor.lxExpansion.background}">
        <p class="blue-grey--text text--lighten-1">{{ formatSalutation() }},</p>
        <p class="blue-grey--text text--lighten-1">{{ $t('AUTH.FIRST_LOGIN.TEXT') }}</p>
        <p class="blue-grey--text text--lighten-1" v-html="$t('AUTH.FIRST_LOGIN.LINK')"></p>
      </div>

      <!-- ACTIONS -->
      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="layout-row layout-align-end-center pa-1">
        <v-btn depressed :color="compColor.prime" :dark="isDarkMode" class="flex white--text text-none mr-1"
               @click="$emit('close', true)">
          {{ $t('AUTH.FIRST_LOGIN.BUTTON_GOTO') }}
        </v-btn>
        <v-btn depressed color="grey" :dark="isDarkMode" class="white--text text-none" @click="$emit('close')">
          {{ $t('buttons.cancel.value') }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'FirstLoginDialog',
  props: {
    showDialogFirstLogin: Boolean
  },
  methods: {
    formatSalutation () {
      const user = (this.authStore.getters.getAuthUserData || {}).user || {}

      let returnValue = ''

      if (user.salutation && user.title && user.lastname) {
        const salutationValue = user.salutation === 'Frau' ? 'geehrte' : 'geehrter'
        returnValue += 'Sehr ' + salutationValue + ' ' + user.salutation + ' ' + user.title + ' ' + user.lastname
      } else {
        returnValue += 'Sehr geehrte Damen und Herren'
      }

      return returnValue
    },
  }
}
</script>

